import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'components/ui'
import { Editor } from '@tinymce/tinymce-react'
import TextField from 'components/form/TextField'
import Checkbox from 'components/form/Checkbox'
import Autocomplete from 'components/form/Autocomplete'
import AutocompleteMultiple from 'components/form/AutocompleteMultiple'
import DateTimePicker from 'components/form/DateTimePicker'

const VodViewShowDrama = (props) => {
  const { control, errors, statusList, peopleTypeList, peopleList, longDescription, editorRef } = props

  /* ----------------------------------------------- */
  /* --------------- Handle Event ------------------ */
  /* ----------------------------------------------- */
  return (
    <div className="vod-view-show-drama-form">
      <Row className="pt-4">
        <Col md={5}>
          <TextField disabled label="Rating (Voted)" name="show_view_rating" control={control} error={errors.show_view_rating} />
        </Col>
        <Col md={5} className="offset-md-2">
          <TextField
            disabled
            label="Title"
            name="show_view_title"
            required
            control={control}
            error={errors.show_view_title}
          />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col md={5}>
          <TextField disabled label="English name" name="show_view_known_as" control={control} error={errors.show_view_known_as} />
        </Col>
        <Col md={5} className="offset-md-2">
          <TextField disabled label="Slug" name="show_view_slug" required control={control} error={errors.show_view_slug} />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col md={5}>
          <TextField disabled label="Short description" name="show_view_short_description" control={control} error={errors.show_view_short_description} />
        </Col>
        <Col md={5} className="offset-md-2">
          <DateTimePicker disabled label="Release Date" name="show_view_release_date" control={control} />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col md={5}>
          <DateTimePicker disabled label="Unrelease Date" name="show_view_unrelease_date" control={control} />
        </Col>
        <Col md={5} className="offset-md-2">
          <TextField disabled type="number" label="Release Year" name="show_view_release_year" control={control} error={errors.show_view_release_year} />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col md={5}>
          <DateTimePicker disabled label="Schedule publish" name="show_view_schedule_date" control={control} />
        </Col>
        <Col md={5} className="offset-md-2">
          <Autocomplete
            disabled
            options={statusList}
            label="Status"
            name="show_view_status"
            control={control}
            error={errors.show_view_status}
          />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col md={5}>
          <TextField disabled type="number" label="Runtime" name="show_view_runtime" control={control} error={errors.show_view_runtime} />
        </Col>
        <Col md={5} className="offset-md-2">
          <TextField disabled type="number" label="Resolution" name="show_view_resolution" control={control} error={errors.show_view_resolution} />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col md={5}>
          <TextField disabled type="number" label="Total Season" name="show_view_total_seasons" control={control} error={errors.show_view_total_seasons} />
        </Col>
        <Col md={5} className="offset-md-2">
          <TextField disabled type="number" label="Views (Real)" name="show_view_real_views" control={control} error={errors.show_view_real_views} />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col md={5}>
          <TextField disabled type="number" label="Views (Fake)" name="show_view_views" control={control} error={errors.show_view_views} />
        </Col>
        <Col md={5} className="offset-md-2">
          <TextField disabled type="number" label="Favorites" name="show_view_favorites" control={control} error={errors.show_view_favorites} />
        </Col>
      </Row>

      <Row className="pt-4">
        <Col md={5}>
          <TextField disabled type="number" label="Intro time" name="show_view_intro_time" control={control} error={errors.show_view_intro_time} />
        </Col>
      </Row>
      <Row className="pt-5">
        <Col md={12}>
          <Checkbox disabled name="show_view_is_single_season" className="d-inline-block" control={control} label="Is Single Season" />
          <Checkbox disabled name="show_view_released" className="ml-4 d-inline-block" control={control} label="Realeased State" />
          <Checkbox disabled name="show_view_is_vip" className="ml-4 d-inline-block" control={control} label="Require VIP" />
          <Checkbox disabled name="show_view_is_drm" className="ml-4 d-inline-block" control={control} label="VOD DRM" />
          <Checkbox disabled name="show_view_is_samsung_preview" className="ml-4 d-inline-block" control={control} label="Samsung Preview" />
        </Col>
      </Row>
      {peopleTypeList && Array.isArray(peopleTypeList) && peopleTypeList.map((item, index) => {
        return (
          <Row className="pt-4" key={index}>
            <Col md={12}>
              <AutocompleteMultiple
                disabled
                options={peopleList}
                label={item.name}
                name={`show_view_people_types_${index}`}
                control={control}
                error={errors.people_types}
              />
            </Col>
          </Row>
        )
      })}
      <Row className="pt-5">
        <Col md={12}>
          {/* <TextField type="textarea" label="Info" name="long_description" control={control} error={errors.long_description} /> */}
          <div className="description-title">Description</div>
          <Editor
            disabled
            apiKey='8xwdiofw91cl5ikp80dpkij70sj7u8uziroarh8v1420aq6y'
            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
            // eslint-disable-next-line no-return-assign
            onInit={(evt, editor) => {
              if (editorRef) {
                editorRef.current = editor
              }
              // setIsLoading(false)
            }}
            initialValue={longDescription}
            init={{
              height: 350,
              branding: false,
              plugins: 'advlist autolink lists link charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime table code help wordcount',
              toolbar: 'undo redo | formatselect | ' +
                'bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

VodViewShowDrama.propTypes = {
  control: PropTypes.any,
  errors: PropTypes.any,
  statusList: PropTypes.array,
  peopleTypeList: PropTypes.array,
  peopleList: PropTypes.array,
  longDescription: PropTypes.string,
  editorRef: PropTypes.any
}

VodViewShowDrama.defaultProps = {
  statusList: [],
  peopleTypeList: [],
  peopleList: [],
  longDescription: ''
}

export default VodViewShowDrama
